import releaseNotesData from './release-notes-data.json'

const getLatestVersion = () => {
  const versions = Object.keys(releaseNotesData)
  if (versions.length === 0) return null

  return versions.sort((a, b) => {
    const parseVer = v => v.replace('v', '').split('.').map(Number)
    const [aMajor, aMinor, aPatch] = parseVer(a)
    const [bMajor, bMinor, bPatch] = parseVer(b)
    if (aMajor !== bMajor) return bMajor - aMajor
    if (aMinor !== bMinor) return bMinor - aMinor
    return bPatch - aPatch
  })[0]
}

export const getWelcomeContent = version => {
  return releaseNotesData[version] || releaseNotesData[getLatestVersion()]
}

export const getVersionSpecificWelcome = version => {
  const content = getWelcomeContent(version)

  return {
    ...content,
    showWelcome: true,
    version
  }
}

export const getDefaultWelcomeContent = () => {
  const latest = getLatestVersion()
  return getWelcomeContent(latest)
}
